import { useState } from 'react';
import { isSeoTraffic } from '../utils/isSeoTraffic';

// Reads `document.referrer` once on mount to detect SEO traffic. Used as a
// client-side fallback when the server-side `Referer` header is missing
const useIsSeoFromDocumentReferrer = () => {
  const [isSeoFromDocumentReferrer] = useState(() => typeof document !== 'undefined' && isSeoTraffic(document.referrer || undefined));

  return isSeoFromDocumentReferrer;
};

export default useIsSeoFromDocumentReferrer;
